<template>
    <section class="section section-components pb-0" id="section-components">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12">

                    <div class="card bg-secondary shadow border-0">
                        <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                            <h3 class="mb-0 safety-header">Community</h3>
                            <span class="arrow">&#9654;</span>
                        </div>
                        <article class="card-body d-none">
                            <a>🤬 Complaints:</a>
                            <ul>
                                <li>
                                    <a target="_blank">311</a><a> - A non-emergency local government service that people can reach by phone or online to report many kinds of problems including noise complaints, rat infestation, sewage issues, animal abuse, and more. Search for local residents complaints in </a>
                                    <a href="https://portal.311.nyc.gov/check-status/" target="_blank">New York</a>
                                    <a>, </a>
                                    <a href="https://311.boston.gov/" target="_blank">Boston</a>
                                    <a>, </a>
                                    <a href="https://dcgis.maps.arcgis.com/apps/webappviewer/index.html?id=dca9e27c4c9d4c24a02cb2c5006beae2" target="_blank">DC</a>
                                    <a>, </a>
                                    <a href="https://311.chicago.gov/s/explore?language=en_US" target="_blank">Chicago</a>
                                    <a>, </a>
                                    <a href="https://data.austintexas.gov/Utilities-and-City-Services/Austin-311-Public-Data/xwdj-i9he/data" target="_blank">Austin</a>
                                    <a>, </a>
                                    <a href="https://myla311.lacity.org/portal/faces/home/dashboard?_afrLoop=41503293996117352&_afrWindowMode=0&_afrWindowId=null&_adf.ctrl-state=13diz32z2z_340#!%40%40%3F_afrWindowId%3Dnull%26_afrLoop%3D41503293996117352%26_afrWindowMode%3D0%26_adf.ctrl-state%3D13diz32z2z_344" target="_blank">Los Angeles</a>
                                    <a>, etc.</a>
                                </li>
                            </ul>
                            <a>🏘️ Neighbors:</a>
                            <ul>
                                <li>
                                    <a href="https://nextdoor.com/" target="_blank">nextdoor.com</a><a> - A social network where people can connect with their neighbors to share local information and ask questions.</a>
                                </li>
                            </ul>
                        </article>
                    </div>

                    <div class="mb-3"></div>

                    <div class="card bg-secondary shadow border-0">
                        <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                            <h1 class="mb-0 safety-header">Demographics</h1>
                            <span class="arrow">&#9654;</span>
                        </div>
                        <article class="card-body d-none">
                            <a>📊 U.S. Census Data</a>
                            <ul>
                                <li>
                                    <a href="https://bestneighborhood.org/" target="_blank">bestneighborhood.org</a><a> - Maps showing areas by race, household income, political leanings, and levels of academic achievement.</a>
                                </li>
                                <li>
                                    <a href="https://arcg.is/0jP4Pq0" target="_blank">arcgis.com</a><a> - A map showing the median age of the population by states, counties, and tracts.</a>
                                </li>
                            </ul>
                        </article>
                    </div>

                    <div class="mb-3"></div>

                    <div class="card bg-secondary shadow border-0">
                        <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                            <h3 class="mb-0 safety-header">Education</h3>
                            <span class="arrow">&#9654;</span>
                        </div>
                        <article class="card-body d-none">
                            <a>🏫 Schools:</a>
                            <ul>
                                <li>
                                    <a href="https://www.niche.com/k12/d/great-neck-public-schools-ny/" target="_blank">niche.com</a><a> - Information about schools including student to teacher ratio, number of students, parent reviews, and more.</a>
                                </li>
                                <li>
                                    <a href="https://www.greatschools.org/" target="_blank">greatschools.org</a><a> - Information about schools including courses and languages offered, racial diversity, and more.</a>
                                </li>
                            </ul>
                            <a>👶 Day Care:</a>
                            <ul>
                                <li>
                                    <a href="https://childcare.gov/" target="_blank">childcare.gov</a><a> - Information about childcare centers including locations, ages served, capacity, years in operation, and more.</a>
                                </li>
                            </ul>
                        </article>
                    </div>

                    <div class="mb-3"></div>

                    <div class="card bg-secondary shadow border-0">
                        <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                            <h3 class="mb-0 safety-header">Food</h3>
                            <span class="arrow">&#9654;</span>
                        </div>
                        <article class="card-body d-none">
                            <a>🍽️ Restaurants:</a>
                            <ul>
                                <li>
                                    <a href="https://friendlycities-gatech.github.io/chainness/" target="_blank">friendlycities-gatech.github.io</a><a> - A map of chain vs independent restaurants.</a>
                                </li>
                            </ul>
                            <a>🥕 Groceries:</a>
                            <ul>
                                <li>
                                    <a href="https://www.usdalocalfoodportal.com/" target="_blank">usdalocalfoodportal.com</a><a> - A map of local food resources including farmers markets, food hubs, and on-farm markets.</a>
                                </li>
                            </ul>
                        </article>
                    </div>

                    <div class="mb-3"></div>

                    <div class="card bg-secondary shadow border-0">
                        <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                            <h3 class="mb-0 safety-header">Government</h3>
                            <span class="arrow">&#9654;</span>
                        </div>
                        <article class="card-body d-none">
                            <a>🗳️ Voting:</a>
                            <ul>
                                <li>
                                    <a href="https://www.nytimes.com/interactive/2021/upshot/2020-election-map.html" target="_blank">nytimes.com</a><a> - An extremely detailed map of the 2020 election results.</a>
                                </li>
                                <li>
                                    <a href="https://www.house.gov/representatives/find-your-representative" target="_blank">house.gov</a><a> - Find district's representatives by zip code.</a>
                                </li>
                            </ul>
                            <a>💸 Taxes:</a>
                            <ul>
                                <li>
                                    <a href="https://taxfoundation.org/data/all/state/property-taxes-by-state-county-2024/" target="_blank">taxfoundation.org</a><a> - A map of property taxes by county.</a>
                                </li>
                            </ul>
                        </article>
                    </div>

                    <div class="mb-3"></div>

                    <div class="card bg-secondary shadow border-0">
                        <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                            <h3 class="mb-0 safety-header">Healthcare</h3>
                            <span class="arrow">&#9654;</span>
                        </div>
                        <article class="card-body d-none">
                            <a>🏥 Hospitals:</a>
                            <ul>
                                <li>
                                    <a href="https://www.medicare.gov/care-compare/?redirect=true&providerType=Hospital" target="_blank">medicare.gov</a><a> - A map of hospitals providing emergency services, including information about the quality of care they provide.</a>
                                </li>
                                <li>
                                    <a href="https://www.hospitalsafetygrade.org/" target="_blank">hospitalsafetygrade.org</a><a> - A hospital safety rating based on dozens of measures of hospital safety, including, for example, the number of surgical patients who died per 1,000 people who had a serious but treatable complication after surgery.</a>
                                </li>
                            </ul>
                            <a>⏳ Life Expectancy:</a>
                            <ul>
                                <li>
                                    <a href="https://www.cdc.gov/nchs/data-visualization/life-expectancy/index.html" target="_blank">cdc.gov</a><a> - Life expectancy data by neighborhood.</a>
                                </li>
                            </ul>
                            <a>🤱 Maternal and Infant Health:</a>
                            <ul>
                                <li>
                                    <a href="https://data.hrsa.gov/maps/mchb" target="_blank">data.hrsa.gov</a><a> - Various data including map of health center service delivery sites, family medicine provider rate (per 100,000), and more.</a>
                                </li>
                            </ul>
                        </article>
                    </div>

                    <div class="mb-3"></div>

                    <div class="card bg-secondary shadow border-0">
                        <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                            <h3 class="mb-0 safety-header">Jobs</h3>
                            <span class="arrow">&#9654;</span>
                        </div>
                        <article class="card-body d-none">
                            <a>🏢 Occupation:</a>
                            <ul>
                                <li>
                                    <a href="https://data.census.gov/table?q=DP03" target="_blank">data.census.gov</a><a> - Check the most common occupations of residents in an area (filter by geos -> zip code tabulation area).</a>
                                </li>
                            </ul>
                        </article>
                    </div>

                    <div class="mb-3"></div>

                    <div class="card bg-secondary shadow border-0">
                        <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                            <h3 class="mb-0 safety-header">Leisure</h3>
                            <span class="arrow">&#9654;</span>
                        </div>
                        <article class="card-body d-none">
                            <a>🏞 Nature:</a>
                            <ul>
                                <li>
                                    <a href="https://www.alltrails.com/" target="_blank">alltrails.com</a><a> - A map of hiking trails, bike trails, and city walking trails.</a>
                                </li>
                                <li>
                                    <a href="https://www.protectedlands.net/map/" target="_blank">protectedlands.net</a><a> - A comprehensive map of lands protected by national, state, county, and city governments.</a>
                                </li>
                            </ul>
                            <a>🎭 Culture:</a>
                            <ul>
                                <li>
                                    <a href="https://www.go-museums.com/museums-map-by-states" target="_blank">go-museums.com</a><a> - A map of museums, botanical gardens, zoos, and aquariums.</a>
                                </li>
                            </ul>
                            <a>🏀 Sport:</a>
                            <ul>
                                <li>
                                    <a href="https://www.usta.com/en/home/play/facility-listing.html#distance=25" target="_blank">usta.com</a><a> - Find a tennis court near in your area.</a>
                                </li>
                            </ul>
                        </article>
                    </div>

                    <div class="mb-3"></div>

                    <div class="card bg-secondary shadow border-0">
                        <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                            <h3 class="mb-0 safety-header">Natural Environment</h3>
                            <span class="arrow">&#9654;</span>
                        </div>
                        <article class="card-body d-none">
                            <a>🫨 Earthquakes:</a>
                            <ul>
                                <li>
                                    <a href="https://maps.openquake.org/map/gshm-2023-1/#4/40.04/-100.48" target="_blank">maps.openquake.org</a><a> - A map of the Global Seismic Hazard Model.</a>
                                </li>
                                <li> 
                                    <a href="https://earthquake.usgs.gov/earthquakes/map/?extent=1.22942,-505.19531&extent=65.69408,-364.57031&range=month&sort=largest" target="_blank">earthquake.usgs.gov</a><a> - A map of earthquakes in the last month.</a>
                                </li>
                                <li>
                                    <a href="https://usgs.maps.arcgis.com/apps/webappviewer/index.html?id=5a6038b3a1684561a9b0aadf88412fcf&showLayers=NSHM_Fault_Sources_9437%3BNSHM_Fault_Sources_9437_1" target="_blank">usgs.maps.arcgis.com</a><a> - A map of fault lines.</a>
                                </li>
                            </ul>
                            <a>🌊 Hurricanes:</a>
                            <ul>
                                <li>
                                    <a href="https://coast.noaa.gov/hurricanes/#map=4/32/-80" target="_blank">coast.noaa.gov</a><a> - A map of historical hurricanes.</a>
                                </li>
                            </ul>
                            <a>🌪️ Tornadoes:</a>
                            <ul>
                                <li>
                                    <a href="https://www.spc.noaa.gov/climo/torn/fatalmap.php" target="_blank">spc.noaa.gov</a><a> - A map of deadly tornadoes by year.</a>
                                </li>
                                <li>
                                    <a href="https://data.usatoday.com/tornado-archive/" target="_blank">data.usatoday.com</a><a> - A map of deadly tornadoes since 1950.</a>
                                </li>
                            </ul>
                            <a>🕳️ Sinkholes:</a>
                            <ul>
                                <li>
                                    <a href="https://www.arcgis.com/apps/mapviewer/index.html?urls=https://ca.dep.state.fl.us/arcgis/rest/services/OpenData/FGS_PUBLIC/MapServer/5,https://ca.dep.state.fl.us/arcgis/rest/services/OpenData/FGS_PUBLIC/MapServer/2,https://ca.dep.state.fl.us/arcgis/rest/services/OpenData/FGS_SUBSIDENCE/MapServer/0&center=-82.4386957719943,27.872337400439594&level=10" target="_blank">arcgis.com</a><a> - A map of sinkholes in Florida.</a>
                                </li>
                                <li>
                                    <a href="https://tnlandforms.us/landforms/sinks.php" target="_blank">tnlandforms.us</a><a> - A map of sinkholes in Tennessee.</a>
                                </li>
                                <li> 
                                    <a href="https://www.usgs.gov/special-topics/water-science-school/science/sinkholes" target="_blank">usgs.gov</a><a> - A map of areas prone to collapse sinkholes in the United States.</a>
                                </li>
                            </ul>
                            <a>🔥 Wildfires</a>
                            <ul>
                                <li>
                                    <a href="https://www.gaiagps.com/maps/source/usfires/?source=hunting" target="_blank">gaiagps.com</a><a> - A map of historical wildfires.</a>
                                </li>
                            </ul>
                            <a>🥵 Heat Waves:</a>
                            <ul>
                                <li>
                                    <a href="https://www.washingtonpost.com/climate-environment/interactive/2022/extreme-heat-risk-map-us/" target="_blank">washingtonpost.com</a><a> - Enter zipcode to check current and future number of days with with a heat index above 100°F.</a>
                                </li>
                            </ul>
                            <a>🌐 Other:</a>
                            <ul>
                                <li>
                                    <a href="https://hazards.fema.gov/nri/map" target="_blank">hazards.fema.gov</a><a> - A map of natural disaster risks (flooding, earthquake, hurricane, heat wave, landslide, tornado, wildfire, etc.) by county or census tract.</a>
                                </li>
                                <li> 
                                    <a href="https://www.wunderground.com/history/monthly/us/az/phoenix/KPHX/date/2024-8" target="_blank">wunderground.com</a><a> - Historical monthly weather data (temperature, precipitation, wind) by city.</a>
                                </li>
                            </ul>
                        </article>
                    </div>

                    <div class="mb-3"></div>

                    <div class="card bg-secondary shadow border-0">
                        <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                            <h3 class="mb-0 safety-header">Pollution</h3>
                            <span class="arrow">&#9654;</span>
                        </div>
                        <article class="card-body d-none">
                            <a>💨 Air Pollution:</a>
                            <ul>
                                <li>
                                    <a href="https://www.airnow.gov/" target="_blank">airnow.gov</a><a> - A map of air quality data collected by the EPA.</a>
                                </li>
                                <li>
                                    <a href="https://commenvcoop.maps.arcgis.com/apps/instant/basic/index.html?appid=be845c680137485cb58412226c7dca59" target="_blank">commenvcoop.maps.arcgis.com</a><a> - A map of landfills across North America.</a>
                                </li>
                            </ul>
                            <a>💡 Light Pollution:</a>
                            <ul>
                                <li><a href="https://www.lightpollutionmap.info/#zoom=9.94&lat=40.6606&lon=-111.6382&state=eyJiYXNlbWFwIjoiTGF5ZXJCaW5nUm9hZCIsIm92ZXJsYXkiOiJ2aWlyc18yMDIzIiwib3ZlcmxheWNvbG9yIjpmYWxzZSwib3ZlcmxheW9wYWNpdHkiOjYwLCJmZWF0dXJlc29wYWNpdHkiOjg1fQ==" target="_blank">lightpollutionmap.info</a><a> - A map with light pollution data collected by VIIRS sensor aboard NASA satelites.</a></li> 
                            </ul>
                            <a>🔊 Noise Pollution:</a>
                            <ul>
                                <li><a href="https://howloud.com/" target="_blank">howloud.com</a><a> - Search for the Soundscore rating of your address, which is determined by three noise factors: vehicle traffic, air traffic, and local sources (such as restaurants, schools, and stores).</a></li>
                            </ul>
                            <a>💧 Water Pollution:</a>
                            <ul>
                                <li>
                                    <a href="https://www.ewg.org/tapwater/" target="_blank">ewg.org</a><a> - Search for contamination in drinking water.</a>
                                </li>
                            </ul>
                        </article>
                    </div>

                    <div class="mb-3"></div>

                    <div class="card bg-secondary shadow border-0">
                        <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                            <h1 class="mb-0 safety-header">Real Estate</h1>
                            <span class="arrow">&#9654;</span>
                        </div>
                        <article class="card-body d-none">
                            <a>🧳 Renting:</a>
                            <ul>
                                <li>
                                    <a href="https://www.arcgis.com/apps/mapviewer/index.html?layers=9c7647840d6540e4864d205bac505027" target="_blank">arcgis.com</a><a> - A map showing percent of renter households for whom rent is 30% or more of household income.</a>
                                </li>
                                <li>
                                    <a href="https://www.zillow.com/rental-manager/market-trends/" target="_blank">zillow.com</a><a> - See rental market summary based on zip code, number of bedrooms, and property type.</a>
                                </li>
                            </ul>
                            <a>💰 Owning:</a>
                            <ul>
                                <li>
                                    <a href="https://www.zillow.com/home-values/102001/united-states/" target="_blank">zillow.com</a><a> - Housing market overview by zip code.</a>
                                </li>
                            </ul>
                            <a>🌐 Other:</a>
                            <ul>
                                <li>
                                    <a href="https://www.arcgis.com/apps/mapviewer/index.html?webmap=8e3b994782444345953a30e2a6e5ab23" target="_blank">arcgis.com</a><a> - A map showing if owner-occupied housing, rented housing, or vacant housing is more prevalent in an area.</a>
                                </li>
                                <li>
                                    <a target="_blank">Buildings Age</a><a> - Maps showing buildings age in </a>
                                    <a href="https://cityhubla.github.io/LA_Building_Age/#12/33.9565/-118.2158" target="_blank">Los Angeles</a>
                                    <a>, </a>
                                    <a href="http://maps.oldersmallerbetter.org/maps/sf/bdg_yr_age_med.html" target="_blank">San Francisco</a>
                                    <a>, </a>
                                    <a href="https://www.reviewjournal.com/local/local-las-vegas/see-how-las-vegas-has-grown-over-the-past-100-years-2530965/" target="_blank">Las Vegas</a>
                                    <a>, </a>
                                    <a href="https://www.bklynr.com/block-by-block-brooklyns-past-and-present/" target="_blank">Brooklyn</a>
                                    <a>, </a>
                                    <a href="https://www.waldrn.com/apps/indybuildingmap/index.html" target="_blank">Indianapolis</a>
                                    <a>, </a>
                                    <a href="https://openseadragon.github.io/openseadragonizer/?img=https%3A%2F%2Fs3.amazonaws.com%2Fmspconstruction%2Fmpls_blg_age-all.png&encoded=true" target="_blank">Minneapolis</a>
                                    <a>, etc.</a>
                                </li>
                            </ul>
                        </article>
                    </div>

                    <div class="mb-3"></div>

                    <div class="card bg-secondary shadow border-0">
                        <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                            <h3 class="mb-0 safety-header">Safety</h3>
                            <span class="arrow">&#9654;</span>
                        </div>
                        <article class="card-body d-none">
                            <a>🚦 Traffic Deaths:</a>
                            <ul>
                                <li>
                                    <a href="https://roadway.report/beta" target="_blank">roadway.report</a><a> - A map of traffic deaths from 2001 - 2022.</a>
                                </li>
                                <li>
                                    <a href="https://storymaps.arcgis.com/stories/9e0e6b7397734c1387172bbc0001f29b" target="_blank">storymaps.arcgis.com</a><a> - A map of fatal crashes hotspots between 2017 - 2021.</a>
                                </li>
                            </ul>
                            <a>🚓 Crime:</a>
                            <ul>
                                <li>
                                    <a href="https://spotcrime.com/" target="_blank">spotcrime.com</a><a> - A map of recent crimes.</a>
                                </li>
                                <li>
                                    <a href="https://koordinates.com/layer/111298-united-states-police-stations/" target="_blank">koordinates.com</a><a> - A map of police stations.</a>
                                </li>
                                <li>
                                    <a href="https://www.thetrace.org/2023/02/gun-violence-map-america-shootings/" target="_blank">thetrace.org</a><a> - A map of gun violence incidents from 2014 - 2023.</a>
                                </li>
                            </ul>
                        </article>
                    </div>

                    <div class="mb-3"></div>

                    <div class="card bg-secondary shadow border-0">
                        <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                            <h3 class="mb-0 safety-header">Transportation</h3>
                            <span class="arrow">&#9654;</span>
                        </div>
                        <article class="card-body d-none">
                            <a>⛽ Gas Prices:</a>
                            <ul>
                                <li>
                                    <a href="https://www.gasbuddy.com/gaspricemap?lat=38.822395&lng=-96.591588&z=4" target="_blank">gasbuddy.com</a><a> - Gas station price heatmap.</a>
                                </li>
                            </ul>
                            <a>🚗 Parking:</a>
                            <ul>
                                <li>
                                    <a href="https://spothero.com/" target="_blank">spothero.com</a><a> - Find paid parking spots.</a>
                                </li>
                            </ul>
                            <a>🚇 Public Transit:</a>
                            <ul>
                                <li>
                                    <a href="https://www.transit.wiki/" target="_blank">transit.wiki</a><a> - Information about public transportation routes and schedules.</a>
                                </li>
                            </ul>
                            <a>🚲 Bike Paths:</a>
                            <ul>
                                <li>
                                    <a href="https://www.bikemap.net/" target="_blank">bikemap.net</a><a> - A map of bike paths, trails, and lanes.</a>
                                </li>
                            </ul>
                            <a>🚶‍♀️ Walking:</a>
                            <ul>
                                <li>
                                    <a href="https://www.walkscore.com/" target="_blank">walkscore.com</a><a> - Get walkability score, transit score, bike score, and check how far you can travel by car, bus, bike and foot from an address within a specific travel time.</a>
                                </li>
                            </ul>
                        </article>
                    </div>

                    <div class="mb-3"></div>

                    <div class="card bg-secondary shadow border-0">
                        <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                            <h3 class="mb-0 safety-header">Utilities</h3>
                            <span class="arrow">&#9654;</span>
                        </div>
                        <article class="card-body d-none">
                            <a>💡 Electricity:</a>
                            <ul>
                                <li>
                                    <a href="https://www.epa.gov/egrid/power-profiler#/" target="_blank">epa.gov</a><a> - Check sources of electricity in area by zipcode.</a>
                                </li>
                            </ul>
                            <a>🛜 Internet:</a>
                            <ul>
                                <li>
                                    <a href="https://broadbandnow.com/research/national-broadband-map" target="_blank">broadbandnow.com</a><a> - A map of internet providers availability, speed, and pricing.</a>
                                </li>
                            </ul>
                        </article>
                    </div>
                    
                    <div class="mb-2 mt-5"></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    mounted() {
        const cardHeaders = document.querySelectorAll('.card-header');
        const cardBodies = document.querySelectorAll('.card-body');
        const arrows = document.querySelectorAll('.arrow');

        cardHeaders.forEach((header, index) => {
            header.addEventListener('click', () => {
                cardBodies[index].classList.toggle('d-none');
                arrows[index].classList.toggle('rotate');
            });
        });
    }
};
</script>

<style>
.card:hover {
    transform: scale(1.05);
}

.arrow {
    transition: transform 0.3s ease;
}

.rotate {
    transform: rotate(90deg);
}
</style>
